import { render, staticRenderFns } from "./takenotelist.vue?vue&type=template&id=a01fd548"
import script from "./takenotelist.vue?vue&type=script&lang=js"
export * from "./takenotelist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports